/** Show body skeleton while the active daily query has no data yet (initial load or new params). */
export function isDailyLiceReportBodyLoading(
    isFetching: boolean,
    isLoading: boolean,
    hasData: boolean
): boolean {
    return isFetching && (isLoading || !hasData);
}
